import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { ACADEMY_LESSON_MANAGING_PROPERTIES_URL, KNOWLEDGE_BASE_CREATE_PROPERTY_URL, KNOWLEDGE_BASE_RECORD_PROPERTIES_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomRecordPropertyModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('CustomRecordPropertyModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.customRecordProperty.heading"
    }),
    illustrationName: "crm-onboarding-add-contact",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.customRecordProperty.description"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: KnowledgeBaseButton
        },
        message: "setup-guide-components.modal.customRecordProperty.p1_jsx",
        options: {
          url: KNOWLEDGE_BASE_RECORD_PROPERTIES_URL,
          onClick: () => trackLink('record properties article')
        }
      })
    }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('create property article'),
      url: KNOWLEDGE_BASE_CREATE_PROPERTY_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: ACADEMY_LESSON_MANAGING_PROPERTIES_URL,
      onClick: () => trackLink('managing properties lesson'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.watchVideo"
      })
    })]
  });
};
CustomRecordPropertyModal.propTypes = {
  onClose: PropTypes.func
};
export default CustomRecordPropertyModal;